import styled from '@emotion/styled'
import React from 'react'
import BreakPoints from '../../styles/breakPoints'
import ColumnH1 from '../atoms/columnH1'
import Introduction004 from './Introduction004'
import Introduction005 from './Introduction005'
import Introduction006 from './Introduction006'
import Introduction007 from './Introduction007'
import Introduction008 from './Introduction008'
import Introduction009 from './Introduction009'
import Introduction010 from './Introduction010'
import Introduction011 from './Introduction011'
import Introduction012 from './Introduction012'

const Wrapper = styled.article`
  position: relative;
  margin-bottom: 30px;

  .p-txt-date {
    margin-top: -10px;
    color: #ababab;
  }

  section {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    font-size: 16px;
    color: #505050;
    line-height: 1.6em;

    h1 {
      color: #414141;
      font-size: 22px;
      line-height: 1.4em;
      background: #f5f5f5;
      border-radius: 3px;
      position: relative;
      width: 100%;
      padding: 5px 5px 5px 20px;
      margin-bottom: 30px;
      margin-top: 10px;

      &:before {
        content: '';
        position: absolute;
        width: 10px;
        background: #77d7c9;
        left: 0;
        top: 0;
        border-radius: 3px 0 0 3px;
        height: 100%;
      }
    }

    h2 {
      color: #414141;
      font-size: 22px;
      line-height: 1.4em;
      background: #ffffff;
      border-radius: 3px;
      position: relative;
      width: 100%;
      padding: 5px 5px 5px 20px;
      margin-top: 10px;
      margin-bottom: 30px;

      &:before {
        content: '';
        position: absolute;
        width: 10px;
        background: #d8d8d8;
        left: 0;
        top: 0;
        border-radius: 3px 0 0 3px;
        height: 100%;
      }
    }

    h3 {
      color: #414141;
      font-size: 16px;
      line-height: 1.4em;
      background: #ffffff;
      width: auto;
      padding: 10px 0 8px;
      margin-top: -10px;
      margin-bottom: 20px;
      border-top: solid 2px #e5e5e5;
      border-bottom: solid 2px #e5e5e5;
    }

    p {
      padding-bottom: 30px;
      line-height: 2;
      position: relative;

      span {
        background: linear-gradient(transparent 60%, #ff6 60%);
        font-weight: 600;
      }

      .p-list-link {
        position: absolute;
        top: 6px;
        right: 2px;

        &:before {
          display: block;
          content: '';
          position: absolute;
          width: 0;
          height: 0;
          top: 7px;
          left: -14px;
          border-left: 8px solid #3ec7b3;
          border-top: 4px solid transparent;
          border-bottom: 4px solid transparent;
        }
      }

      &.txt-color-red {
        color: #ff6969;
      }
    }

    .link-div {
      width: 100%;
      display: flex;
      justify-content: left;
      padding-bottom: 30px;

      > div {
        width: 50px;
      }

      .link-p {
        width: calc(100% - 50px);

        .p-list-link {
          position: absolute;
          top: -3px;
          left: 30px;

          &:before {
            display: block;
            content: '';
            position: absolute;
            width: 0;
            height: 0;
            top: 11px;
            left: -14px;
            border-left: 8px solid #3ec7b3;
            border-top: 4px solid transparent;
            border-bottom: 4px solid transparent;
          }
        }
      }
    }

    img {
      width: 100%;
      height: auto;
      padding-bottom: 30px;
    }
  }

  ${BreakPoints.large} {
  }
`
type Props = {
  /** 広告の番号 */
  no: number
}

/**
 * コラム記事詳細：記事本体
 * @constructor
 */
const ColumnDetailInner0079 = (props: Props): JSX.Element => (
  <Wrapper>
    <ColumnH1 label="勤怠の締め日にはどんな作業をする？締め作業を軽減する方法とは？" />
    {/** TODO 川上申し送り事項：▼投稿日をここに表示 */}
    <p className="p-txt-date">2025.02.28</p>
    <section>
      {/** TODO 川上申し送り事項：▼記事投稿（？）で作成された内容がここに入る予定 */}
      <p>
        「勤怠」と「給与」は密接に関連しており、勤怠管理が杜撰な場合は、副次的に給与も不適切な計算となります。特に複数の職種から形成される企業の場合は、勤怠管理も複雑であり、様々な「落とし穴」があることから、重要度は増します。そこで最終段階である勤怠の締め日にやるべき事にフォーカスをあて、解説します。
      </p>
      <img src="/images/column/details/c0079.jpg" alt="キンクラコラム画像79" />
      <div id="toc1">
        <h1>勤怠とは</h1>
      </div>
      <p>
        勤怠とは「勤怠」という法律用語は存在しませんが、一般的には労働者の出退勤状況を指しています。出勤日数や欠勤日数、労働時間、残業時間等が挙げられますが、言うまでもなく、全ての情報が給与と密接に関連しますので、重要であることは明らかであり、適切に把握しなければなりません。
      </p>

      <div id="toc2">
        <h1>どんな作業をするのか？</h1>
      </div>
      <p>
        近年はITツールの発達で勤怠管理は容易になりました。ただし、作業自体が簡略化されただけであり、確認すべき内容まで簡略すると思わぬ形でミスに繋がることがあります。給与計算には必ず月に1度の給与支給日が存在しますので、その日から逆算して勤怠締め日が設定されています。人数が増えれば増えるほど手間がかかりますので、締め日から逆算して定期的に（申請忘れのチェックなど）アナウンスをしていくことが必要です。多くの企業で
        <span>
          各労働者が申請し、部門長が承認後に人事労務部門（企業によって名称は異なる)が精査
        </span>
        を行います。
        <br />
        <br />
        ここでは具体的な作業内容にも注視します。まず、
        <span>出退勤時刻のデータが存在しない労働者への確認</span>
        です。出退勤時刻のデータが存在しないということは、出勤していないのか、有給休暇を申請した日なのか、あるいは出勤して残業まで行ったもののそもそも打刻を失念していたのか判断ができません。もちろん、労働者の過失として片付けることも選択肢としてはあります。ただし、出勤して残業まで行っていた場合は、未払い賃金となり法令違反となります。この部分は必ず確認が必要ですので労働者の過失として確認を怠ることは企業にとってもリスクがあります。
        <br />
        <br />
        また、
        <span>有給休暇なのか、欠勤なのか判別できない日についても確認</span>
        が求められます。2019年4月1日以降は年休10日以上の有給休暇が付与される労働者に対しては、付与された日から1年以内に5日の取得義務が課せられています。これに反すると企業には30万円以下の罰金が課せられます。この考え方は「1人1罪」となり、未達成者が増えれば増えるほど罰金額は増えるという理屈です。有給休暇は労働関係法令上、唯一賃金支払義務が課せられている休暇であり、給与支給額にも直結することから確認漏れが許されない部分になります。
        <br />
        <br />
        他には有給休暇の取得日数や残業時間など、勤怠データは企業に義務として課せられている管理項目と直接結びつくところが多いこと、付随するその他の管理台帳等など勤怠データと合わせてチェックすべきデータもリストアップした上で、
        <span>打刻データとの整合性を確認する</span>
        体制が求められますので、影響を与える範囲が多いと言え、ある程度、逆算した業務スケジュールを組む必要性が高いと言えます。
      </p>

      {/** ここに9パターンの広告設定する */}
      {props.no === 0 && <Introduction004 />}
      {props.no === 1 && <Introduction005 />}
      {props.no === 2 && <Introduction006 />}
      {props.no === 3 && <Introduction007 />}
      {props.no === 4 && <Introduction008 />}
      {props.no === 5 && <Introduction009 />}
      {props.no === 6 && <Introduction010 />}
      {props.no === 7 && <Introduction011 />}
      {props.no === 8 && <Introduction012 />}

      <div id="toc3">
        <h1>締め作業を軽減するためには？</h1>
      </div>
      <p>
        従業員数が増えれば増えるほど確認項目が多くなることから、勤怠の煩雑さは増す傾向にあります。特に、シフト制で土日も勤務する従業員がいるとなれば、煩雑さはより拍車がかかります。一部機械化するとしても全く人の目を通さずに業務を完遂させることはできませんので、何らかの軽減策を講じなければいずれはミスが起きてしまうことが想定されます。そこで、具体的な軽減策の1点目は、中間チェック者の配置です。前提として、従業員数が10人未満程度であれば、中間チェック者は必須ではないものの、10人以上となれば「第三者」を配置して勤怠にエラーがある場合には定期的に注意喚起する役割を付与すべきです。勤怠は給与と紐づく業務であり、給与は間違いがないことが前提ですので、明らかに従業員側に落ち度があったとしても「給与は別問題」と考えられているケースが多く、会社側の落ち度と認識されがちです。特にこの傾向は月給者に多く、確かに時給者の場合は労働時間が基本給に対して直接的に反映されますが、月給者の場合は既に月額の基本給が決定していますので、「間違いが起こる」ということへの理解が得にくいということです。
        <br />
        <br />
        2点目はやはり、<span>システムの導入</span>
        です。「コンサル」をはじめとしたシステムよりも人間のほうが勝る部分はあるものの、数字のチェックに関しては人間が機械を勝ることは困難と言わざるを得ません。特に給与と紐づく遅刻早退時間や有給休暇の集計等、
        <span>可能な限りシステム化をすることでヒューマンエラーを回避</span>
        し、人的リソースを本来注ぐべき部分に投入できるメリットの大きさは無視できません。他方、システムを導入したからといって使いこなせなければ全く意味がありませんので、実務担当者同席のもと、主観的な意見（扱いやすさやどの程度機能を備えているか）も汲みながらどのシステムを導入すべきかを判断すべきと考えます。
      </p>

      <div id="toc4">
        <h1>最後に</h1>
      </div>
      <p>
        勤怠は人を雇用する企業であれば必ず「毎月」発生するものであり、仮に全期間欠勤であったとしても社会保険加入者であれば社会保険料の問題があります。勤怠は毎月必ず発生するものであり、企業が確認すべき項目は法改正の内容によっては今後ますます増えていくことが予想されます。そうなると、ヒューマンリソースの有効活用の為にも、システム化のメリットは非常に大きいと言えます。
      </p>
    </section>
  </Wrapper>
)

export default ColumnDetailInner0079
